import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionError = ({
  condition,
  showConditionErrors = false,
  spaceStyleProps = {
    marginBlockStart: '100'
  }
}) => {
  let errorMessage;
  if (showConditionErrors && condition.errors.length) {
    errorMessage = condition.errors[0].message;
  } else if (showConditionErrors && condition.dateRefinement && condition.dateRefinement.errors.length) {
    errorMessage = condition.dateRefinement.errors[0].message;
  } else if (showConditionErrors && condition.numberRefinement && condition.numberRefinement.errors.length) {
    errorMessage = condition.numberRefinement.errors[0].message;
  }
  if (errorMessage) {
    return /*#__PURE__*/_jsx(Text, Object.assign({
      display: "block",
      typography: "heading-25",
      use: "error"
    }, spaceStyleProps, {
      children: errorMessage
    }));
  }
  return null;
};
export default ConditionError;